import { render, staticRenderFns } from "./ReactionCanvas.vue?vue&type=template&id=1477480e&scoped=true&"
import script from "./ReactionCanvas.vue?vue&type=script&lang=js&"
export * from "./ReactionCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ReactionCanvas.vue?vue&type=style&index=0&id=1477480e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477480e",
  null
  
)

export default component.exports